import React, { useRef, useState } from "react";
import { useEffect } from "react";
import CommonContainer from "../Container/CommonContainer";
import CommonPagination from "../../Common/CommonPagination";
import * as SalesAdminLoginTrackingReportService from "../../Services/MHL_Reports/SalesAdminLoginTrackingReportService";
import {
  FaSearch,
  FaSpinner,
  FaFileExcel,
  FaCaretDown,
  FaCaretUp,
  FaDownload,
} from "react-icons/fa";
import toast from "react-hot-toast";
import "react-datepicker/dist/react-datepicker.css";
import { formatVisitDate } from "../../Common/CommonVariables";
import * as XLSX from "xlsx";

const SalesAdminLoginTrackingReportComponent = () => {
  const [loginData, setLoginData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isDownloadingReport, setIsDownloadingReport] = useState(false);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 15;

  const getLoginTrackingData = () => {
    setLoading(true);
    SalesAdminLoginTrackingReportService.SalesAdminLoginTrackingReport()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setLoginData(data?.Data);
        } else {
          setLoginData([]);
        }
      })
      .catch(() => {
        setLoginData([]);
      })
      .finally(() => setLoading(false));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    getLoginTrackingData();
  }, []);

  const filteredLoginData = loginData.filter((data) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      data.FirstName?.toLowerCase().includes(lowerSearch) ||
      data.LastName?.toLowerCase().includes(lowerSearch) ||
      data.Role_Name?.toLowerCase().includes(lowerSearch) ||
      data.Device_Type?.toString().includes(searchTerm)
    );
  });

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentLoginData = filteredLoginData.slice(indexOfFirst, indexOfLast);

  const handleDownloadReport = async () => {
    try {
      setIsDownloadingReport(true);

      if (filteredLoginData.length === 0) {
        toast.error("No data available to download");
        return;
      }

      const dataForExcel = filteredLoginData.map((data) => ({
        // "User ID": data?.UserId ?? "-",
        "Email ID": data?.EmailId ?? "-",
        "First Name": data?.FirstName ?? "-",
        "Last Name": data?.LastName ?? "-",
        // "Role ID": data?.RoleId ?? "-",
        "Role Name": data?.Role_Name ?? "-",
        "Login Count": data?.Login_Count ?? 0,
        "Last Login Date": formatVisitDate(data?.Last_Login_Date) ?? "-",
      }));

      const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Sales Admin Login Tracking",
      );

      worksheet["!cols"] = [
        { wch: 10 },
        { wch: 30 },
        { wch: 18 },
        { wch: 18 },
        { wch: 10 },
        { wch: 20 },
        { wch: 12 },
        { wch: 20 },
        { wch: 15 },
      ];

      const filename = `Sales_Admin_Login_Tracking_Report.xlsx`;

      XLSX.writeFile(workbook, filename);

      toast.success("Report downloaded successfully");
    } catch (error) {
      toast.error("Failed to download report");
    } finally {
      setIsDownloadingReport(false);
    }
  };

  return (
    <CommonContainer heading="Sales Admin Login Tracking">
      <div
        className="d-flex flex-column flex-lg-row mb-2 gap-2 search-sm"
        style={{ justifyContent: "space-between" }}
      >
        <div className="d-flex align-items-md-center gap-2 custom-date-range">
          <div className="d-flex flex-column flex-md-row gap-2 justify-content-between mb-2">
            <div className="d-flex">
              {currentLoginData && currentLoginData.length > 0 && (
                <button
                  className="btn custom-sumbitbtn d-flex align-items-center justify-content-center gap-2"
                  onClick={handleDownloadReport}
                  title="Download Report"
                >
                  {isDownloadingReport ? (
                    <>
                      <FaSpinner className="w-5 h-5 fa-spin" />
                    </>
                  ) : (
                    <>
                      Download Excel <FaDownload className="d-flex" size={18} />
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="search-box" style={{ position: "relative" }}>
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={searchTerm}
            onChange={handleSearch}
            style={{
              paddingRight: "35px",
              borderRadius: "5px",
              border: "1px solid #ddd",
            }}
          />
          <button
            className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-box-btn"
            style={{
              padding: "5px",
              position: "absolute",
              right: "0px",
              height: "35px",
              width: "45px",
              top: "55%",
              borderTopLeftRadius: "0",
              borderBottomLeftRadius: "0",
              transform: "translateY(-55%)",
            }}
            onClick={() => setCurrentPage(1)}
          >
            <FaSearch />
          </button>
        </div>
      </div>

      <div className="mt-3 mt-lg-2">
        <div className="table-responsive mhl-partner-login-report-table">
          <table className="table table-bordered custom-table">
            <thead>
              <tr>
                {/* <th>User ID</th> */}
                <th>User Name</th>
                <th>Email ID</th>
                {/* <th>Role ID</th> */}
                <th>Role Name</th>
                <th>Login Count</th>
                <th>Last Login Date</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: "10px" }}>
              {loading ? (
                <tr>
                  <td colSpan="5" className="text-center py-2">
                    <FaSpinner size={18} color="green" className="fa-spin" />
                  </td>
                </tr>
              ) : currentLoginData?.length > 0 ? (
                currentLoginData?.map((data, index) => (
                  <tr className="patient-list-row" key={index}>
                    {/* <td>{data?.UserId}</td> */}
                    <td>
                      {data?.FirstName} {data?.LastName}
                    </td>
                    <td>{data?.EmailId}</td>
                    {/* <td>{data?.RoleId ?? 0}</td> */}
                    <td>{data?.Role_Name ?? "-"}</td>
                    <td>{data?.Login_Count ?? 0}</td>
                    <td>{formatVisitDate(data?.Last_Login_Date) ?? "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No Data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {filteredLoginData.length > itemsPerPage && (
          <CommonPagination
            pageList={filteredLoginData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
    </CommonContainer>
  );
};

export default SalesAdminLoginTrackingReportComponent;
